/* global axios */
import ApiClient from './ApiClient';

class BranchesAPI extends ApiClient {
  constructor() {
    super('branches', { accountScoped: true });
  }

  async uploadLogo(id, file) {
    const form = new FormData();
    form.append('logo', file);
    const res = await axios.post(`${this.url}/${id}/logo`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  }

  async removeLogo(id) {
    const res = await axios.delete(`${this.url}/${id}/logo`);
    return res.data;
  }
}

export default new BranchesAPI();
